import "./Home.css";
import Me from "../../assets/avatar-1.png";
import HeaderSocials from "./HeaderSocials";
import ScrollDown from "./ScrollDown";
import Shapes from "./Shapes";

const Home = () => {
  return (
    <section className="home container" id="home">
      <div className="intro">
        <img
          src={Me}
          alt="My Profile Pic"
          className="home__img"
        />

        <h1 className="home__name">
          William Tran
        </h1>

        <span className="home__education">
          Software Engineer Intern @ Square
        </span>

        <HeaderSocials />

        <a href="#contact" className="btn">
          Contact Me
        </a>

        <ScrollDown />
      </div>

      <Shapes />
    </section>
  )
}

export default Home
